import { noop } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { useTranslate } from "context/translateContext"
import { reloadPage } from "shared/helpers/browser"

import styles from "./ErrorComponent.module.css"

export const ErrorComponent = ({
  tryAgain,
  message,
  icon,
  action,
  reloadOnClick,
}) => {
  const { t: translate } = useTranslate()
  const onClickHandler = reloadOnClick ? reloadPage : tryAgain

  return (
    <div className={styles.root}>
      <span className={icon} />
      {message && (
        <div
          data-testid="error-component-message-wrapper"
          className="fs-12 c-motive--dark"
        >
          {message}
        </div>
      )}
      {(action || reloadOnClick) && (
        <button
          type="button"
          className={styles.button}
          onClick={() => onClickHandler(action)}
        >
          {translate("Try again")}
        </button>
      )}
    </div>
  )
}

ErrorComponent.propTypes = {
  tryAgain: PropTypes.func,
  action: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  icon: PropTypes.string,
  message: PropTypes.node,
  reloadOnClick: PropTypes.bool,
}

ErrorComponent.defaultProps = {
  tryAgain: noop,
  icon: "icon-ghost",
  action: null,
  message: "Oops! Something went wrong",
  reloadOnClick: false,
}

const mapDispatchToProps = dispatch => ({
  tryAgain: action => dispatch(action),
})

export default connect(null, mapDispatchToProps)(ErrorComponent)
